import { gql } from '@apollo/client';

export const GET_LOGIN = gql`query MyQuery {
  queryUser(filter: {username: {allofterms: "agent"}, password: {allofterms: "1234"}}) {
    role
    id
  }
}`;
export const GET_BUILDER_DATA = gql`query MyQuery($id: [ID!]) {
  queryItinerary(filter: {id: $id}) {
    id
  }
}`;
export const VACATION_TYPE_QUESTION = gql`query MyQuery($key: StringTermFilter = {allofterms: "tripOccasion"}) {
  queryTravelQuestion(filter: {key: $key, type: {eq: WorldExploration}}) {
    defaultValue
    answerChoices {
      id
      sortOrder
      tooltip
      isAlwaysSelected
      displayRow
      value
    }
  }
}`;
export const BUDGET_QUESTION = gql`query MyQuery($key: StringTermFilter = {allofterms: "tripBudget"}) {
  queryTravelQuestion(filter: {key: $key, type: {eq: WorldExploration}}) {
    defaultValue
    answerChoices {
      id
      sortOrder
      tooltip
      isAlwaysSelected
      displayRow
      value
    }
  }
}`;
export const GET_ANSWERS = gql`query MyQuery($key: String) {
  queryTravelAnswer(filter: {key: {anyofterms: $key}}) {
    id
    key
    name
    phone
    sharedEmails
    email
    from
    destination
    startDate
    endDate
    adultsCount
    kidsCount
    budget
    vacationType
    interests
    amenities
    roomRequirement
    resortRquirements
    importantInfo
    previouslyStayedResortInfo
    comment
    tours
    cities
    attractions
    stayRequirements
    submitTime
    summary
  }
}`;
export const GET_ITINERARY_FULLdd = gql`query MyQuery($key: String) {
  queryItinerary(filter: {key: {anyofterms: $key}}) {
   id
  startDate
  endDate
  tourOperator
  tourOperatorConfirmationNumber

   persons {
        id
         firstname
         lastname
         dateOfBirth
      }
   media {
        id
        keywords
        type
        url
      }

  travelAdvisory
  comment
  submitTime
  days{
  id
  date
}
  }
}
`;
export const GET_ITINERARY_FULL = gql`query MyQuery($key: String) {
  queryItinerary(filter: {key: {allofterms: $key}}) {
    id
    key
    startDate
    endDate
    isPackagePrice
    tourOperator
    tourOperatorConfirmationNumber
    name
    type
    description
    tripOverview
    customUrls{
      id
      name
      url
    }
   
    travelAnswer{
      id
    key
    name
    phone
    email
     sharedEmails
    from
    destination
    startDate
    endDate
    adultsCount
    kidsCount
    budget
    vacationType
    interests
    amenities
    roomRequirement
    resortRquirements
    importantInfo
    previouslyStayedResortInfo
    comment
    tours
    cities
    attractions
    stayRequirements
    submitTime
    summary
    }
    tripAdvisoryConfirmation{
      id
      name
      url
    }
    media {
      id
      url
      displayName
    }
    persons {
      id
      firstname
      lastname
      dateOfBirth
    }
    tripAdvisory {
      id
      displayName
      url
    }
    healthAdvisory {
      id
      url
    }
    emergencyContacts {
      email
      id
      name
      phone
      comment
    }
    importantInformations {
      id
      contact
      email
      information
      type
    }
    comment
    submitTime
    parentRef{
      key
      id
      key
      name
    }
    shares{
      id
      name
    }
    cloneRef{
      id
      key
      name
    }
    days(order: {asc: date}) {
      id
      date
      stayPoint
      importantInformation
      details
      cancellationPolicy
      internalComment
      confirmations(filter: {not: {isDeleted: true }}) {
        id
        url
        name
      }
      media{
        id
        url
        displayName
      }
      contacts{
        id
        name
        email
        phone
      }
       dayAdditionalInformation{
            id
            tittle
            time
            description
          }
      dayAccommodations {
        id
        bookedDays
        cancellationPolicy
        checkInDate
        checkInTime
        checkOutDate
        checkOutTime
        comment
        confirmationNumber
        extraRequest
        guestNames
        isVisible
         persons {
              id
              dateOfBirth
              firstname
              lastname
            }
        netPrice
        bookingStatus
        accommodationFlights{
          id
          flight {
            airlineName
            arrivalAirport
            departure{
            id
            timeZone
            airportCode
          }
          arrival{
            id
            timeZone
            airportCode
          }
            arrivalAirportCode
            comments
            departureAirport
            departureAirportCode
            flgithNumber
            flightOperatedByAirline
            flightOperatedByFlightNbr
               id
          }
        }
        benchmarkPrice
        packagePrice
        payNow
        seaparatePrice
        publishedPrice
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        accommodation {
          id
          street
          street2
          type
          locality
          adultsOnly
          website
          city
          description
          numberOfStars
          rating
          country
          email
          name
          phone
          stateProvince
          zip
          media {
            id
            url
            displayName
          }
        }
        accommodationRoom {
          id
          beds
          comment
          maxOccupancy
          name
          size
          media {
            id
            url
          }
        }
        accommodationRooms {
          id
          beds
          comment
          maxOccupancy
          name
          size
          media {
            id
            url
          }
          roomAmenities{
            id
            image
            type
          }
        }
        roomDetails{
          count
          id
          price
          checked
          comment
          roomDetail{
            id
            beds
            comment
            maxOccupancy
            name
            size
            media {
              id
              url
            }
            roomAmenities{
              id
              image
              type
            }  
          }
        }
      }
      dayActivities {
        id
        isVisible
        cancellationPolicy
        children
        adults
        comment
        confirmationNumber
         persons {
              id
              dateOfBirth
              firstname
              lastname
            }
        date
        dateOfBooking
        durationHours
        netPrice
        payNow
        participants
        bookingStatus
        publishedPrice
        isAddToSuggession
        startPoint
        meetingPointInfo
        startTime
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        activity {
          id
          name
          description
          comment
          groupType
          provider
          type
          media {
            id
            url
            displayName
          }
        }
      }
      dayFlights {
        adults
        isVisible
        arrivalDate
        arrivalTime
        cabinType
        children
        cancellationPolicy
        comment
        price
        dateOfBooking
        bookingStatus
        departDate
        departTime
        flightCabinType
        id
        netPrice
        publishedPrice
        connectionFlightOrder
        connectionFlights{
          adults
        isVisible
        arrivalDate
        arrivalTime
        cabinType
        children
        cancellationPolicy
        comment
        price
        dateOfBooking
        bookingStatus
        departDate
        departTime
        flightCabinType
        id
        netPrice
        publishedPrice
        connectionFlightOrder
         flight {
          airlineName
          arrivalAirport
          departure{
            id
            timeZone
            airportCode
          }
          arrival{
            id
            timeZone
            airportCode
          }
          arrivalAirportCode
          comments
          departureAirport
          departureAirportCode
          flgithNumber
          logo{
            displayName
            id
            keywords
            type
            url
          }
          flightOperatedByAirline
          flightOperatedByFlightNbr
          id
        }
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        recordLocator
        operatedByAirlineRecordLocator
        }
        returnItineraryFlight{
           adults
        isVisible
        arrivalDate
        arrivalTime
        cabinType
        children
        cancellationPolicy
        comment
        price
        dateOfBooking
        bookingStatus
        departDate
        departTime
        flightCabinType
        id
        netPrice
        publishedPrice
        connectionFlightOrder
           flight {
            airlineName
            arrivalAirport

            departure{
            id
            timeZone
            airportCode
          }
            
          arrival{
            id
            timeZone
            airportCode
          }
            arrivalAirportCode
            comments
            departureAirport
            departureAirportCode
            flgithNumber
             logo{
            displayName
            id
            keywords
            type
            url
          }
            flightOperatedByAirline
            flightOperatedByFlightNbr
               id
          }
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        recordLocator
        operatedByAirlineRecordLocator
   connectionFlights{
          adults
        isVisible
        arrivalDate
        arrivalTime
        cabinType
        children
        cancellationPolicy
        comment
        price
        dateOfBooking
        bookingStatus
        departDate
        departTime
        flightCabinType
        id
        netPrice
        publishedPrice
        connectionFlightOrder
         flight {
          airlineName
          arrivalAirport
          departure{
            id
            timeZone
            airportCode
          }
          arrival{
            id
            timeZone
            airportCode
          }
          arrivalAirportCode
          comments
          departureAirport
          departureAirportCode
          flgithNumber
          logo{
            displayName
            id
            keywords
            type
            url
          }
          flightOperatedByAirline
          flightOperatedByFlightNbr
          id
        }
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        recordLocator
        operatedByAirlineRecordLocator
        }
        }
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        recordLocator
        operatedByAirlineRecordLocator
        flight {
          airlineName
          arrivalAirport
          departure{
            id
            timeZone
            airportCode
          }
          arrival{
            id
            timeZone
            airportCode
          }
          arrivalAirportCode
          comments
          departureAirport
          departureAirportCode
          flgithNumber
          logo{
            displayName
            id
            keywords
            type
            url
          }
          flightOperatedByAirline
          flightOperatedByFlightNbr
          id
        }
      }
      dayTransfers {
        isVisible
        adults
        bookingDate
        children
        comment
        finishPoint
        bookingStatus
        id
        netPrice
        price
        cancellationPolicy
        providerConfirmationNumber
        publishedPrice
        startPoint
        startTime
        transferDate
        type
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        transfer {
          id
          locality
          providerEmail
          providerName
          providerPhone
        }
      }
      dayInsurances {
        id
        comment
        confirmationPolicyNumber
        netPrice
        cancellationPolicy
        policyDocument
        bookingStatus
        publishedPrice
        tripCost
        address
        effectiveDate
        departureDate
        returnDate
        depositDate
        payNow
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        insurance {
          id
          provider
          plan
          state
        }
        insuredPersons {
          id
          dateOfBirth
          firstname
          lastname
        }
      }
      dayCarRentals {
        isVisible
        publishedPrice
        payNow
        carRental {
          companyName
          media{
          id
          url
          }
        }
        provider
        id
        cancellationPolicy
        dateOfBooking
        carType
        carBrand
        bookingStatus
        carAmenities
        pickUpLocation
        pickUpDate
        pickUpTime
        luggageCount
        doorCount
        passengerCount
        price
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        driver {
          firstname
          lastname
        }
        dropOffLocation
        dropOffDate
        dropOffTime
        payingArrangement
        comment
      }
      dayCruises {
        isVisible
        bookingStatus
        cancellationPolicy
        cabins {
          beds
          cabinCategory
          cabinName
          comment
          
          id
          maxOccupancy
          roomAmenities
          size
          media {
            displayName
            id
            keywords
            type
            url
          }
        }
        cabin {
          beds
          cabinCategory
          cabinName
          comment
          
          id
          maxOccupancy
          roomAmenities
          size
          media {
            displayName
            id
            keywords
            type
            url
          }
        }
        comment
        confirmationNumber
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        cruise {
          comment
          cruiseContactEmail
          cruiseContactPhone
          cruiseLineName
          cruiseRouteName
          departurePort
          id
          media {
            displayName
            id
            keywords
            type
            url
          }
          logo{
            displayName
            id
            keywords
            type
            url
          }
          numberOfNights
          returnPort
          shipName
        }
        cruiseDays
        deckNumber
        departureDate
        id
        netPrice
        numberOfAdults
        numberOfChildren
        persons {
          dateOfBirth
          firstname
          id
          lastname
        }
        publishedPrice
        request
        returnDate
        departureTime
        returnTime
      }
      daySeqNumber
      port
      timeAtPort
      description
      comment
      dayTrains {
        isVisible
        adults
        arrivalDate
        price
        arrivalTime
        carNumber
        children
        class
        bookingStatus
        comment
        dateOfBooking
        departDate
        departTime
        cancellationPolicy
        flexibility
        id
        netPrice
        publishedPrice
        seatNumber
        trainNumber
        trainType
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        train {
          arrivalCity
          arrivalTrainStation
          comment
          departureCity
          departureTrailStation
          id
          trainCompany
          trainTripName
          logo{
          url
          }
        }
        persons {
          dateOfBirth
          firstname
          id
          lastname
        }
      }
      dayRestaurants {
        isVisible
        adults
        children
        bookingDate
        cancellationPolicy
        comment
        date
        bookingStatus
        durationHours
        isAddToSuggession
        id
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        reservationName
        startTime
        restaurant {
          id
          address
          comment
          cuisine
          description
          media {
            id
            displayName
            url
          }
          name
          phone
          pricing
          stars
          website
        }
        media {
          id
          displayName
          url
        }
      }
      dayFerries {
        isVisible
        adults
        arrivalDate
        arrivalTime
        children
        bookingStatus
        confirmationNumber
        class
        comment
        price
        confirmations(filter: {not: {isDeleted: true }}) {
          id
          name
          url
        }
        dateOfBooking
        departDate
        departTime
        ferry {
          arrivalPort
          comment
          logo{
            displayName
            id
            keywords
            type
            url
          }
          departurePort
          ferryCompany
          id
        }
        flexibility
        id
        name
        netPrice
        persons {
          dateOfBirth
          firstname
          id
          lastname
        }
        publishedPrice
        seatNumber
        shipType
        amenities {
          comment
          id
          image
          type
        }
      }
    }
  }
}
  `;
export const GET_USERPROFILE_DATA = gql`query MyQuery
($email:String)
{
    queryUserProfile(filter:{email:{allofterms:$email}}) {
      id
      firstName
      lastName
      phone
      email
      dateCreated
      picture{
        id
        url
      }
      wishList{
        id
        key
        name
        startDate
        endDate
        media{
          id
          url
        }
        travelAnswer{
          id
        }
      }
        }
        
    }`;

export const GET_PERSONAL_DATA = gql`query MyQuery($email:String){
  queryTravelAnswer(order: {desc: submitTime},filter: {email: {allofterms: $email}, or: {sharedEmails: {allofterms: $email}}}) {
        adultsCount
        amenities
        budget
        childrenAges
        comment
        destination
        email
        endDate
        from
        id
        importantInfo
        interests
        kidsCount
        lapChildrenCount
        name
        phone
        previouslyStayedResortInfo
        resortRquirements
        roomRequirement
        startDate
        submitTime
        tripDateFelxibility
        vacationType
        bookingItems
        tripDateFelxibility
        summary
        key
        itineraries{
          id
          key
          type
          startDate
          endDate
          name
          media{
            id
            url
          }
          travelAnswer{
            id
            key
          }
        days(order: {asc: date}) {
        id
        date
        dayActivities{
        publishedPrice
        activity{
        name
        }
        paymentRecords{
        paymentId
        paymentDate
        title
        description
        type
        cardToken
        amount
        }
        }
        }
        }
      }
      
  }`;